import React from 'react';
import Logo from '../../Asets/common/logo.svg';

const LogoImg:React.FC = () =>{
  return(
    <img src={`${Logo}`} alt="創造の細胞"/>
  )
}

export default LogoImg;